// Animation data mock
export const animationCategories = [
  {
    id: 'basic',
    name: 'Basic',
    animations: [
      { id: 'scale-up', name: 'scale-up', variations: ['scale-up-center', 'scale-up-top', 'scale-up-bottom', 'scale-up-left', 'scale-up-right'] },
      { id: 'scale-down', name: 'scale-down', variations: ['scale-down-center', 'scale-down-top', 'scale-down-bottom'] },
      { id: 'rotate', name: 'rotate', variations: ['rotate-center', 'rotate-top', 'rotate-bottom'] },
      { id: 'flip', name: 'flip', variations: ['flip-horizontal', 'flip-vertical', 'flip-diagonal'] },
      { id: 'slide', name: 'slide', variations: ['slide-top', 'slide-bottom', 'slide-left', 'slide-right'] },
    ]
  },
  {
    id: 'entrances',
    name: 'Entrances',
    animations: [
      { id: 'fade-in', name: 'fade-in', variations: ['fade-in', 'fade-in-top', 'fade-in-bottom', 'fade-in-left', 'fade-in-right'] },
      { id: 'slide-in', name: 'slide-in', variations: ['slide-in-top', 'slide-in-bottom', 'slide-in-left', 'slide-in-right'] },
      { id: 'bounce-in', name: 'bounce-in', variations: ['bounce-in', 'bounce-in-top', 'bounce-in-bottom'] },
      { id: 'roll-in', name: 'roll-in', variations: ['roll-in-left', 'roll-in-right'] },
    ]
  },
  {
    id: 'exits',
    name: 'Exits',
    animations: [
      { id: 'fade-out', name: 'fade-out', variations: ['fade-out', 'fade-out-top', 'fade-out-bottom'] },
      { id: 'slide-out', name: 'slide-out', variations: ['slide-out-top', 'slide-out-bottom', 'slide-out-left', 'slide-out-right'] },
      { id: 'bounce-out', name: 'bounce-out', variations: ['bounce-out', 'bounce-out-top', 'bounce-out-bottom'] },
    ]
  },
  {
    id: 'attention',
    name: 'Attention Seekers',
    animations: [
      { id: 'pulsate', name: 'pulsate', variations: ['pulsate-fwd', 'pulsate-bck', 'pulsate-fwd-bck'] },
      { id: 'shake', name: 'shake', variations: ['shake-horizontal', 'shake-vertical', 'shake-lr'] },
      { id: 'wobble', name: 'wobble', variations: ['wobble-hor-bottom', 'wobble-hor-top', 'wobble-ver-left', 'wobble-ver-right'] },
      { id: 'bounce', name: 'bounce', variations: ['bounce-top', 'bounce-bottom', 'bounce-left', 'bounce-right'] },
      { id: 'jello', name: 'jello', variations: ['jello-horizontal', 'jello-vertical', 'jello-diagonal'] },
      { id: 'vibrate', name: 'vibrate', variations: ['vibrate-1', 'vibrate-2', 'vibrate-3'] },
      { id: 'flicker', name: 'flicker', variations: ['flicker-1', 'flicker-2', 'flicker-3'] },
      { id: 'blink', name: 'blink', variations: ['blink-1', 'blink-2'] },
    ]
  },
  {
    id: 'text',
    name: 'Text',
    animations: [
      { id: 'tracking', name: 'tracking', variations: ['tracking-in-expand', 'tracking-in-contract', 'tracking-out-expand'] },
      { id: 'focus', name: 'focus', variations: ['focus-in-expand', 'focus-in-contract'] },
      { id: 'blur', name: 'blur', variations: ['blur-out-expand', 'blur-out-contract'] },
    ]
  },
  {
    id: 'background',
    name: 'Background',
    animations: [
      { id: 'color-change', name: 'color-change', variations: ['color-change-2x', 'color-change-3x', 'color-change-4x'] },
      { id: 'bg-pan', name: 'bg-pan', variations: ['bg-pan-left', 'bg-pan-right', 'bg-pan-top', 'bg-pan-bottom'] },
    ]
  }
];

export const timingFunctions = [
  { id: 'linear', name: 'linear', value: 'linear' },
  { id: 'ease', name: 'ease', value: 'ease' },
  { id: 'ease-in', name: 'easeIn', value: 'ease-in' },
  { id: 'ease-out', name: 'easeOut', value: 'ease-out' },
  { id: 'ease-in-out', name: 'easeInOut', value: 'ease-in-out' },
  { id: 'ease-in-quad', name: 'easeInQuad', value: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)' },
  { id: 'ease-in-cubic', name: 'easeInCubic', value: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)' },
  { id: 'ease-out-quad', name: 'easeOutQuad', value: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' },
  { id: 'ease-out-cubic', name: 'easeOutCubic', value: 'cubic-bezier(0.215, 0.61, 0.355, 1)' },
  { id: 'ease-in-out-quad', name: 'easeInOutQuad', value: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)' },
  { id: 'ease-in-back', name: 'easeInBack', value: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)' },
  { id: 'ease-out-back', name: 'easeOutBack', value: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)' },
];

export const directions = [
  { id: 'normal', name: 'normal' },
  { id: 'reverse', name: 'reverse' },
  { id: 'alternate', name: 'alternate' },
  { id: 'alternate-reverse', name: 'alternate-reverse' },
];

export const fillModes = [
  { id: 'none', name: 'none' },
  { id: 'forwards', name: 'forwards' },
  { id: 'backwards', name: 'backwards' },
  { id: 'both', name: 'both' },
];

export const previewObjects = [
  { id: 'box-dark', name: 'Box Dark', type: 'box', variant: 'dark' },
  { id: 'box-light', name: 'Box Light', type: 'box', variant: 'light' },
  { id: 'circle', name: 'Circle', type: 'circle' },
  { id: 'button', name: 'Button', type: 'button' },
  { id: 'text', name: 'Text', type: 'text' },
  { id: 'letter', name: 'Letter', type: 'letter' },
  { id: 'card', name: 'Card', type: 'card' },
];

export const defaultAnimationSettings = {
  duration: 500,
  delay: 0,
  iterationCount: 1,
  direction: 'normal',
  timingFunction: 'ease',
  fillMode: 'both',
};
